import gql from 'graphql-tag';

import publicAccountFragment from '../fragments/publicAccountFragment';

export const mutationCreateProviderAccessTokenOAuth = gql`
  mutation createProviderAccessTokenOAuth(
    $code: String!
    $redirectURI: String!
    $provider: CreateTokenOAuthProvider!
  ) {
    createProviderAccessTokenOAuth(
      code: $code
      redirectURI: $redirectURI
      provider: $provider
    ) {
      providerAccessToken
      providerAccessTokenVerificationHash
      existingAccounts {
        dokkioClass
        total
        accounts {
          ...publicAccountFragment
        }
      }
    }
  }
  ${publicAccountFragment}
`;

export default mutationCreateProviderAccessTokenOAuth;
